import { getValue } from "@utils/lodash";
import "./filter-form.scss";
// import AddFilterNew from "../AddFilterNew";
import InputField from "@_common/InputRuleFeild";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import ResetSvgComponent from "../../../assets/svg-components/reset";


export default function ManageAuditFilterForm(props: any) {
  const { countryList, states, citiesList, handleChangeSelect } = props;
  return (
    <div
      className={`filter-slidder-wrapper  ${
        props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
      }`}
    >
      <div className="filter-form-wrappper w-100 active">
        <div className="filter-form-wrappper__container">
          {/* {getValue(props, `submitText`, "") ? null : (
            <div className="d-flex align-items-center justify-content-between my-1">
              <h6 className="filter-form-wrappper__title">Filter by Test ManageAuditFilterForm</h6>
              <div></div>
              <img
                src="/images/close-black.svg"
                className="img-fluid cursor-pointer"
                onClick={props.setFilterFormVisibility}
              />
            </div>
          )} */}
          
          <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
            <div className="filter-header-left-wrapper d-flex align-items-center">
              <div className="filter-close-wrapper">
                <img src="/images/close-circle.svg" className="img-fluid cursor-pointer" onClick={props.handleFilter} />
              </div>
              <div className="filter-title-wrapper">
                <h6 className="filter-form-wrappper__title">Filter</h6>
              </div>
              
              <div className="filter-module-details-wrapper">
                <div className="filter-module-name">{props.moduleName}</div>
                <div className="filter-submodule-name">{props.subModuleName}</div>
              </div>
            </div>

            <div className="filter-header-right-wrapper">
              <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
              {!getValue(props, `hideReset`, false) && (
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                    onClick={props.reset}
                  >
                    <div className="d-flex align-items-center mt--3">
                      <ResetSvgComponent  size={24} color={"#5F6368"} /> Reset
                    </div>
                  </button>
                )}

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                  onClick={props.handleFilter}
                >
                  Cancel
                </button>
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                  onClick={props.handleSubmitSmartFilter}
                >
                  {getValue(props, `submitText`, "")
                    ? getValue(props, `submitText`, "")
                    : "Search"}
                </button>
              </div>
            </div>
          </div>

          <div className="filter-body-wrapper">
            <div className="filter-body-card">
              <div className="filter-card-title">
                Filter By
              </div>
              <div className="d-flex justify-content-between gap">
                {/* <div className="filter-form-wrappper__location flex-2"> */}
                <div className="dashboard-self-compliance manage-audit-content-holder">
                  <>
                    <div
                      className={`d-flex cursor-pointer`}
                      style={{ flexWrap: "wrap" }}
                    >
                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-0 mb-3 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            Region
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose Region`}
                              options={getValue(props, `regionList`, [])}
                              searchLoading={props.regionLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getRegionsList(val, "")
                                  : props.handleRemoveFilter("region_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "region_id"
                                )
                              }
                              value={getValue(props, `region_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"region_id"}
                              disabled={props.disableRegion}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}
                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-3 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            Account
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose Account`}
                              options={getValue(props, `groupsList`, [])}
                              searchLoading={props.groupLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getGroupsList(
                                      val,
                                      getValue(props, `request.group_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("group_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "group_id"
                                )
                              }
                              value={getValue(props, `group_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"group_id"}
                              disabled={props.disableGroup}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}

                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-3 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            State
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose State`}
                              options={getValue(props, `stateList`, [])}
                              searchLoading={props.stateLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getStatesList(
                                      val,
                                      getValue(props, `request.region_id`, ""),
                                      getValue(props, `request.group_id`, ""),
                                      // getValue(props, `request.state_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("state_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "state_id"
                                )
                              }
                              value={getValue(props, `state_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"state_id"}
                              disabled={props.disableGroup}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}
                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-3 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            City
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose City`}
                              options={getValue(props, `cityList`, [])}
                              searchLoading={props.cityLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getCitiesList(
                                      val,
                                      getValue(props, `request.region_id`, ""),
                                      getValue(props, `request.group_id`, ""),
                                      getValue(props, `request.state_id`, ""),
                                      // getValue(props, `request.city_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("city_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "city_id"
                                )
                              }
                              value={getValue(props, `city_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"city_id"}
                              disabled={props.disableGroup}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}

                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-3 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            Site
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose Site`}
                              options={getValue(props, `locationsList`, [])}
                              searchLoading={props.locationLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getLocationsList(
                                      val,
                                      getValue(props, `request.region_id`, ""),
                                      getValue(props, `request.group_id`, ""),
                                      getValue(props, `request.state_id`, ""),
                                      getValue(props, `request.city_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("location_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "location_id"
                                )
                              }
                              value={getValue(props, `location_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"location_id"}
                              disabled={props.disableLocation}
                              // removeClose
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}
                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-0 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            Vendor
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose Vendor`}
                              options={getValue(props, `vendorsList`, [])}
                              searchLoading={props.vendorLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getVendorList(
                                      val,
                                      getValue(props, `request.region_id`, ""),
                                      getValue(props, `request.group_id`, ""),
                                      getValue(props, `request.state_id`, ""),
                                      getValue(props, `request.city_id`, ""),
                                      getValue(props, `request.location_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("vendor_id")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "vendor_id"
                                )
                              }
                              value={getValue(props, `vendor_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"vendor_id"}
                              // removeClose
                              disabled={props.disableVendor}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div style={{ marginLeft: "30px" }}></div> */}
                      <div
                        className="position-relative form-group  align-items-center cursor-pointer mb-0 manage-audit-fields-wrapper"
                        key={`location-`}
                      >
                        <div>
                          <label
                            htmlFor="law"
                            className="filter-form-wrappper__label manage-audit-fields-label"
                          >
                            Audit Status
                          </label>
                          <div className="filter-form-wrappper__location-input">
                            <SearchableDropdownSelect
                              placeholder={`Choose Audit Status`}
                              options={getValue(props, `auditTypeList`, [])}
                              searchLoading={props.auditTypeLoading}
                              handleChange={(val: any) =>
                                val
                                  ? props.getAuditTypeList(
                                      val,
                                      getValue(props, `request.region_id`, ""),
                                      getValue(props, `request.group_id`, ""),
                                      getValue(props, `request.state_id`, ""),
                                      getValue(props, `request.city_id`, ""),
                                      getValue(props, `request.location_id`, ""),
                                      getValue(props, `request.vendor_id`, ""),
                                      ""
                                    )
                                  : props.handleRemoveFilter("audit_type")
                              }
                              handleClick={(e: any) =>
                                props.handleSelectFilter(
                                  getValue(e, `id`, ""),
                                  "audit_type"
                                )
                              }
                              value={getValue(props, `audit_type_ID[${0}]`, "")}
                              label="label"
                              id="id"
                              name={"audit_type"}
                              // removeClose
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </>
                </div>
                {/* </div> */}
                {/* <div className="filter-form-wrappper__location flex-2"></div> */}
                {/* <div className="filter-form-wrappper__location flex-2"></div> */}
              </div>
            </div>
          </div>
        </div>

        <div className="filter-form-wrappper__cta-wrapper d-none">
          <button
            className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
            onClick={props.handleSubmitSmartFilter}
          >
            {getValue(props, `submitText`, "")
              ? getValue(props, `submitText`, "")
              : "Search"}
          </button>
          {!getValue(props, `hideReset`, false) && (
            <button
              className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
              onClick={props.reset}
            >
              Reset
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
